import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginComponent from "./Auth/Login";
import SignUp from "./Auth/SignUp";

import ShopDashboard from "./ShopPages/DashboardPage/Dashboard";
import ShopHomeContent from "./ShopPages/DashboardPage/DashboardComponents/DashboardHome";
import ShopProductManager from "./ShopPages/ActivityListing/ActivityListing";
import ShopBooking from "./ShopPages/EventBookings/EventBookings";
import ShopReview from "./ShopPages/UserReviews/UserReviews";
import ShopEarnings from "./ShopPages/Earnings/Earnings";
import ShopProfile from "./ShopPages/ShopProfile/ShopProfile";

import ActivityDashboard from "./ActivityPages/DashboardPage/Dashboard";
import ActivityHomeContent from "./ActivityPages/DashboardPage/DashboardComponents/DashboardHome";
import ActivityTaskManager from "./ActivityPages/ActivityListing/ActivityListing";
import ActivityBooking from "./ActivityPages/EventBookings/EventBookings";
import ActivityReview from "./ActivityPages/UserReviews/UserReviews";
import ActivityEarnings from "./ActivityPages/Earnings/Earnings";
import ActivityProfile from "./ActivityPages/ActivityProfile/ActivityProfile";
import AddExperiencePage from "./ActivityPages/ActivityListing/AddExperiencePage";
import ExperiencePreviewPage from "./ActivityPages/ActivityListing/ExperiencePreviewPage";

import RestaurantDashboard from "./RestaurantPages/DashboardPage/Dashboard";
import RestaurantHomeContent from "./RestaurantPages/DashboardPage/DashboardComponents/DashboardHome";
import RestaurantBooking from "./RestaurantPages/EventBookings/EventBookings";
import RestaurantReview from "./RestaurantPages/UserReviews/UserReviews";
import RestaurantEarnings from "./RestaurantPages/Earnings/Earnings";
import RestaurantProfile from "./RestaurantPages/RestaurantProfile/RestaurantProfile";
import Layout from "./Layout.jsx";
import PrivacyPolicy from "./PrivacyPolicy";
import AuthLayout from "./Auth/AuthLayout";

import WalletPage from "./components/Wallet/WalletPage";
import SupportPage from "./components/Support/SupportPage";
const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: "/",
            element: <LoginComponent />,
          },
          {
            path: "/login",
            element: <LoginComponent />,
          },
          {
            path: "/signup",
            element: <SignUp />,
          },
        ]
      },
      {
        path: "/shop",
        element: <ShopDashboard />,
        children: [
          {
            path: "",
            element: <ShopHomeContent />,
          },
          {
            path: "profile",
            element: <ShopProfile />,
          },
          {
            path: "listing",
            element: <ShopProductManager />,
          },
          {
            path: "booking",
            element: <ShopBooking />,
          },
          {
            path: "reviews",
            element: <ShopReview />,
          },
          {
            path: "payments",
            element: <ShopEarnings />,
          },
          {
            path: "wallet",
            element: <WalletPage />,
          },
          {
            path: "support",
            element: <SupportPage />,
          },
        ],
      },
      {
        path: "/activity",
        element: <ActivityDashboard />,
        children: [
          {
            path: "",
            element: <ActivityHomeContent />,
          },
          {
            path: "profile",
            element: <ActivityProfile />,
          },
          {
            path: "add-experience",
            element: <AddExperiencePage />,
          },
          {
            path: "preview-experience/:id",
            element: <ExperiencePreviewPage />,
          },
          {
            path: "listing",
            element: <ActivityTaskManager />,
          },
          {
            path: "booking",
            element: <ActivityBooking />,
          },
          {
            path: "reviews",
            element: <ActivityReview />,
          },
          {
            path: "payments",
            element: <ActivityEarnings />,
          },
          {
            path: "wallet",
            element: <WalletPage />,
          },
          {
            path: "support",
            element: <SupportPage />,
          },
        ],
      },
      {
        path: "/restaurant",
        element: <RestaurantDashboard />,
        children: [
          {
            path: "",
            element: <RestaurantHomeContent />,
          },
          {
            path: "profile",
            element: <RestaurantProfile />,
          },
          {
            path: "booking",
            element: <RestaurantBooking />,
          },
          {
            path: "reviews",
            element: <RestaurantReview />,
          },
          {
            path: "payments",
            element: <RestaurantEarnings />,
          },
          {
            path: "wallet",
            element: <WalletPage />,
          },
          {
            path: "support",
            element: <SupportPage />,
          },
        ],
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
